import NavbarLayout from "components/Layout/NavbarLayout";
import * as DateIso from "@tiicker/util/lib/date-iso";
import Head from "next/head";
import styles from "./SimpleLayout.module.scss";
import GenericBadgeTags from "components/GenericBadgeTags/GenericBadgeTags";
import { QuickQuote, QuickQuoteProps } from "components/Quotes/QuickQuote";
import MobileLayout from "components/Layout/MobileLayout";
import classnames from "classnames";
import Container from "components/core/Layout/Container/Container";
import getBaseUrl from "@tiicker/util/lib/get-base-url";

type Props = {
  title: string;
  description: string;
  url: string;
  imageUrl?: string;
  badge?: string;
  author?: string;
  date: DateIso.Type;
  symbols: Array<string>;
  slug: string;
  isMobile?: boolean;
  children: React.ReactNode;
  beforeFooter?: React.ReactNode;
};

const SimpleLayout = (props: Props) => {
  const quickQuoteData: QuickQuoteProps[] = props.symbols.map((s) => {
    return {
      tickerSymbol: s,
    };
  });
  const WrapperLayout = props.isMobile ? MobileLayout : NavbarLayout;
  const description = "The companies you own want to reward you! TiiCKER.COM makes it easy to discover stock perks you may qualify for based on your individual share ownership."
  const title = "TiiCKER.com"
  const imgUrl = props.imageUrl

  return (
    <>
      <Head>
        <title>{props.title} | TiiCKER</title>
        <meta
          name="description"
          key="meta-description"
          content={props.description || description}
        />
        <meta property="og:title" key="title" content={props.title || title} />
        <meta property="og:url" key="url" content={props.url || getBaseUrl().toString()} />

        <meta property="og:image" key="image" 
              content={props.imageUrl?.startsWith("//")? props.imageUrl?.slice(2) : props.imageUrl || `${getBaseUrl()}images/TiickerTM-WhiteBackground.png`} 
        />
        
        <meta
          property="og:description"
          key="description"
          content={props.description}
        />
      </Head>
      <WrapperLayout>
        <div
          className={classnames(
            styles.SimpleLayout,
            props.isMobile ? styles.SimpleLayout__mobile : undefined
          )}
        >
          <Container>
            <div className={styles.SimpleLayout__heroContainer}>
              <div className={styles.SimpleLayout__headerDetails}>
                {props.badge && (
                  <span className={styles.SimpleLayout__topicBadge}>
                    {props.badge}
                  </span>
                )}
                <div className={styles.SimpleLayout__authorDate}>
                  {props.author && <p>{props.author}</p>}
                  <p className={styles.SimpleLayout__date}>
                    {DateIso.formatLongMonthDayYear(props.date)}
                  </p>
                </div>
              </div>
              <h1 className={styles.SimpleLayout__title}>{props.title}</h1>
              {props.imageUrl && <img src={props.imageUrl} />}
            </div>
          </Container>
          {quickQuoteData.length > 0 && (
            <GenericBadgeTags<QuickQuoteProps>
              listComponent={QuickQuote}
              listData={quickQuoteData}
              listDisplayLength={8}
            />
          )}
          <Container>{props.children}</Container>
        </div>
        {props.beforeFooter}
      </WrapperLayout>
    </>
  );
};

export default SimpleLayout;
